module.exports = __webpack_public_path__ + "static/media/new.b7720ce6.png";